// Utility to fetch currency setting from backend
export async function fetchCurrencySetting() {
  try {
    const res = await fetch('/api/settings/tax-currency');
    if (!res.ok) throw new Error('Failed to fetch currency');
    const data = await res.json();
    return data.currency || 'USD';
  } catch {
    return 'USD';
  }
}
